import { FlowConsumerContextEnergy as FlowContext } from '../../context';

export const shouldSkipWhenNoGasUpsellProductAvailable = (context: FlowContext): boolean => {
  const { isGasUpsellProductAvailable } = context;

  return !isGasUpsellProductAvailable;
};
